"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgReloadBackward = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "M2.667 13.333S5.34 9.691 7.512 7.518A11.96 11.96 0 0 1 16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12c-5.47 0-10.087-3.661-11.531-8.667m-1.802-6v-8m0 8h8" }))); };
exports.default = SvgReloadBackward;
//# sourceMappingURL=ReloadBackward.js.map